
import Admin from '@/views/Admin.vue';
import Payments from '@/views/admin/Payments.vue';
import ListPayments from '@/views/admin/payments/ListPayments.vue';
import NewPayment from '@/views/admin/payments/NewPayment.vue';
import EditPayment from '@/views/admin/payments/EditPayment.vue';
import Discounts from '@/views/admin/Discounts.vue';
import ListDiscounts from '@/views/admin/discounts/ListDiscounts.vue';
import NewDiscount from '@/views/admin/discounts/NewDiscount.vue';
import EditDiscount from '@/views/admin/discounts/EditDiscount.vue';
import Team from '@/views/admin/Team.vue';
import Calendar from '@/views/admin/Calendar.vue';
import CalendarMonth from '@/views/admin/calendar/CalendarMonth.vue';
import CalendarDay from '@/views/admin/calendar/CalendarDay.vue';
import Strips from '@/views/admin/Strips.vue';
import ListStrips from '@/views/admin/strips/ListStrips.vue';
import EditStrip from '@/views/admin/strips/EditStrip.vue';
import UploadStrips from '@/views/admin/strips/UploadStrips.vue';
import Site from '@/views/admin/Site.vue';
import ManageAbout from '@/views/admin/site/ManageAbout.vue';
import ManageContact from '@/views/admin/site/ManageContact.vue';
import ManagePress from '@/views/admin/site/ManagePress.vue';
import ManageOptions from '@/views/admin/site/ManageOptions.vue';
import Characters from '@/views/admin/Characters.vue';
import ListCharacters from '@/views/admin/characters/ListCharacters.vue';
import EditCharacter from '@/views/admin/characters/EditCharacter.vue';
import NewCharacter from '@/views/admin/characters/NewCharacter.vue';
import Seasons from '@/views/admin/Seasons.vue';
import ListSeasons from '@/views/admin/seasons/ListSeasons.vue';
import NewSeason from '@/views/admin/seasons/NewSeason.vue';
import EditSeason from '@/views/admin/seasons/EditSeason.vue';

export default [
  {
    name: 'Admin',
    path: '/manage',
    component: Admin,
    children: [
      {
        path: 'seasons',
        component: Seasons,
        children: [
          {
            name: 'ListSeasons',
            path: '',
            component: ListSeasons,
          },
          {
            name: 'NewSeason',
            path: 'new',
            component: NewSeason,
          },
          {
            name: 'EditSeason',
            path: ':id',
            component: EditSeason,
            props: true,
          },
        ],
      }, {
        path: 'calendar',
        component: Calendar,
        children: [
          {
            name: 'CalendarMonth',
            path: '',
            component: CalendarMonth,
          },
          {
            name: 'CalendarDay',
            path: ':publishDate',
            component: CalendarDay,
            props: true,
          },
        ],
      }, {
        path: 'strips',
        component: Strips,
        children: [
          {
            name: 'ListStrips',
            path: '',
            component: ListStrips,
          },
          {
            name: 'UploadStrips',
            path: 'upload',
            component: UploadStrips,
          },
          {
            name: 'EditStrip',
            path: ':stripNumber',
            component: EditStrip,
            props: true,
          },
        ],
      }, {
        path: 'payments',
        component: Payments,
        children: [
          {
            name: 'ListPayments',
            path: '',
            component: ListPayments,
          },
          {
            name: 'NewPayment',
            path: 'new',
            component: NewPayment,
          },
          {
            name: 'EditPayment',
            path: ':id',
            component: EditPayment,
            props: true,
          },
        ],
      }, {
        path: 'discounts',
        component: Discounts,
        children: [
          {
            name: 'ManageDiscounts',
            path: '',
            component: ListDiscounts,
          },
          {
            name: 'NewDiscount',
            path: 'new',
            component: NewDiscount,
          },
          {
            name: 'EditDiscount',
            path: ':id',
            component: EditDiscount,
            props: true,
          },
        ],
      },
      {
        path: 'about',
        component: Site,
        children: [
          {
            name: 'ManageAbout',
            path: '',
            component: ManageAbout,
          },
          {
            name: 'ManageContact',
            path: 'contact',
            component: ManageContact,
          },
          {
            name: 'ManagePress',
            path: 'press',
            component: ManagePress,
          },
          {
            name: 'ManageOptions',
            path: 'options',
            component: ManageOptions,
          },
        ],
      }, {
        path: 'characters',
        component: Characters,
        children: [
          {
            name: 'ListCharacters',
            path: '',
            component: ListCharacters,
          },
          {
            name: 'NewCharacter',
            path: 'new',
            component: NewCharacter,
          },
          {
            name: 'EditCharacter',
            path: ':id',
            component: EditCharacter,
            props: true,
          },
        ],
      }, {
        name: 'ManageTeam',
        path: 'team',
        component: Team,
      },
    ],
  },
];
